import { AppError } from "./errors";
import type { GroupTalkReportResponse } from "./api";
import type { GroupTalkTurnView } from "./groupTalkView";

export const GROUP_TALK_REPORT_NOT_READY_MESSAGE =
  "まだ論点整理を作成できるだけの壁打ち内容がありません。もう1ターン進めてからお試しください。";
export const GROUP_TALK_REPORT_CONFLICT_MESSAGE = "論点整理を作成中です。少し待ってから再読み込みしてください。";
export const GROUP_TALK_REPORT_GENERAL_ERROR_MESSAGE =
  "論点整理の取得または作成に失敗しました。時間をおいて再度お試しください。";
export const GROUP_TALK_REPORT_FAILED_MESSAGE = "論点整理の作成に失敗しました。時間をおいてもう一度お試しください。";

export function formatGroupTalkReportGeneratedAt(value: string | undefined) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Asia/Tokyo",
  }).format(date);
}

export function getGroupTalkReportActionErrorMessage(errorValue: unknown) {
  if (errorValue instanceof AppError) {
    if (errorValue.meta.status === 422) return GROUP_TALK_REPORT_NOT_READY_MESSAGE;
    if (errorValue.meta.status === 409) return GROUP_TALK_REPORT_CONFLICT_MESSAGE;
  }

  return GROUP_TALK_REPORT_GENERAL_ERROR_MESSAGE;
}

export function getGroupTalkCompletedReportTitle(report: GroupTalkReportResponse) {
  return report.title?.trim() || "論点整理レポート";
}

export function isGroupTalkReportStale(report: GroupTalkReportResponse | null) {
  return report?.status === "completed" && report.is_stale === true;
}

export function canRegenerateGroupTalkReport(report: GroupTalkReportResponse | null) {
  return report?.can_regenerate !== false;
}

export function markGroupTalkReportFresh(report: GroupTalkReportResponse): GroupTalkReportResponse {
  if (report.status !== "completed") return report;
  return {
    ...report,
    is_stale: false,
    can_regenerate: false,
  };
}

export function hasGroupTalkSummaryMessage(turns: GroupTalkTurnView[]) {
  return turns.some((turn) => turn.messages.some((message) => message.phase === "summary"));
}
